const authHeaderFile=()=>{
    const token = localStorage.getItem("token");
    if(token){
        return {
            'Authorization' : "Bearer " + token,
            'Content-Type': 'multipart/form-data'};
    }
    else return {};
}

export default authHeaderFile;